import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { PageContent, PageTitle, Flex, Link, Button } from 'nallian-shared-ui/lib/components';
import HasRight from 'nallian-shared-ui/lib/layout/rights/HasRight';
import { Table, Actions, Params } from 'nallian-table-builder-ui';
import {
  INFINITE_SCROLL,
  COMMUNITIES_RESOURCE,
  ACTIONS,
  COMMUNITY_DETAIL_TABS,
} from '../constants';
import apiRoutes from '../../../app/api/routes';
import NewCommunity from './details/NewCommunity';

const CommunitiesOverview = () => {
  const { t } = useTranslation();
  const { action } = useParams();
  return (
    <>
      <PageTitle>{t('communitiesOverview')}</PageTitle>
      <PageContent>
        <HasRight right="COMMUNITIES.MANAGE.ALL">
          <Flex fluid>
            <Link to="/communities/create">
              <Button btnprimary icon="plus" content={t('newCommunity')} />
            </Link>
          </Flex>
        </HasRight>
        <NewCommunity open={action === 'create'} />
        <Table
          url={apiRoutes.getCommunities()}
          infiniteScroll={INFINITE_SCROLL}
          resource={COMMUNITIES_RESOURCE}
          pageSize={50}
          noUserSettings
          resizable
          filtered
        >
          <Actions.Link
            width="2.5rem"
            align="center"
            icon="eye"
            url={`/communities/${ACTIONS.EDIT}/:id/${COMMUNITY_DETAIL_TABS.DETAILS}`}
          />
          <Params.String name="name" width="9rem" minWidth="9rem" grow />
          <Params.String name="tag" width="9rem" minWidth="9rem" grow />
          <Params.String name="id" width="16rem" minWidth="16rem" grow noFilter />
          <Params.String name="tenantId" width="16rem" minWidth="16rem" grow noFilter />
        </Table>
      </PageContent>
    </>
  );
};

export default CommunitiesOverview;
